import { render, staticRenderFns } from "./LoadingSimple.vue?vue&type=template&id=586c1fc5&scoped=true"
import script from "./LoadingSimple.vue?vue&type=script&lang=js"
export * from "./LoadingSimple.vue?vue&type=script&lang=js"
import style0 from "./LoadingSimple.vue?vue&type=style&index=0&id=586c1fc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586c1fc5",
  null
  
)

export default component.exports